/**
 * Export component file to be used on project
 */

import ProfessionalProfile from './ProfessionalProfile';
export default ProfessionalProfile;
